import addLotsAuctionStep2 from './addLotsAuctionStep2';

export default {
    init() {
        addLotsAuctionStep2.lotsSidebarDynamicColumnToggle();
        $('.column-type-drop a').eq(0).trigger('click');
        addLotsAuctionStep2.editLotsRowPriceOrQtyPopUp();
        addLotsAuctionStep2.quickView();
        // addLotsAuctionStep2.quickViewHistoryToggle();
        addLotsAuctionStep2.sidebarRemoveSingleItem();
        addLotsAuctionStep2.lotsLogToggle();
        addLotsAuctionStep2.packedListOrder();
        addLotsAuctionStep2.removeItemFromPack();
        // addLotsAuctionStep2.lotsListPaginationInput();
    }
}